export default __webpack_public_path__ + "static/media/settings.6efd814a.svg";